<script setup lang="ts">
import type { Typography } from '../../types/Typography';

const props = withDefaults(defineProps<{
  element?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'p' | 'span' | 'div';
  type?: Typography;
}>(), {
  element: 'p',
  type: 'body-1'
});
</script>

<template>
  <component :is="props.element" data-testid="typography" :class="`font-${props.type}`">
    <slot></slot>
  </component>
</template>

<style></style>
